import React, { createContext, useContext, useState } from "react";

const NavbarContext = createContext();

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error("useNavbar must be used within a NavbarProvider");
  }
  return context;
};

export const NavbarProvider = ({ children }) => {
  const [showNavbar, setShowNavbar] = useState(false);

  const toggleNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const hideNavbar = () => {
    setShowNavbar(false);
  };

  return (
    <NavbarContext.Provider value={{ showNavbar, setShowNavbar, toggleNavbar, hideNavbar }}>
      {children}
    </NavbarContext.Provider>
  );
};
